import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableFooter,
  Avatar,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Panel from "common/components/Panel";
import Resource from "common/components/Resource";
import Pagination from "common/components/Pagination";

const ListFoodOrderingManagement = ({ classes, match, history }) => (
  <Panel title="View Food Order Provider">
    <Resource
      name="food_supplier_master"
      render={(data, { removeOne, prevPage, nextPage, page }) => (
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Logo</TableCell>
              <TableCell>Provider</TableCell>
              <TableCell>Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length ? (
              data.map((element) => (
                <TableRow hover key={element.id}>
                  <TableCell>{element.id}</TableCell>
                  <TableCell>
                    <Avatar alt="Logo" src={element.url} />
                  </TableCell>
                  <TableCell
                    className={classes.clickable}
                    onClick={() => history.push(`${match.url}/${element.id}`)}
                  >
                    {element.name}
                  </TableCell>
                  <TableCell>
                    <IconButton>
                      <DeleteIcon onClick={() => removeOne(element.id)} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4}>No additional data found.</TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell colSpan={4} className={classes.pagination}>
                <Pagination
                  page={page}
                  nextPage={nextPage}
                  prevPage={prevPage}
                  items={data}
                />
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      )}
    />
  </Panel>
);

const styles = (theme) => ({
  clickable: {
    cursor: "pointer",
    color: theme.palette.primary.light,
    fontWeight: "bold",
  },
  table: {
    minWidth: 700,
  },
  pagination: {
    textAlign: "right",
  },
});

ListFoodOrderingManagement.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListFoodOrderingManagement);
